import { Dashboard } from '@/components';
import { EditProfile } from '@/components/AccountManagement/Profile/EditProfile';

export const EditProfilePage = () => (
  <Dashboard isChecked={true} openLogIn>
    <EditProfile />
  </Dashboard>
);
